<template>
    <el-dialog title="Déclinaisons" v-loading="loader" :visible.sync="display" width="90%">
        <div class="mb-3">Regrouper en déclinaison</div>
        <el-alert v-if="displayWarningDeclinaison" title="Attention" type="warning" show-icon description="Les lignes en jaune on des variations qui seront réatribués à la variation principale">
        </el-alert>
        <el-alert v-if="error" :title="errorMessage" type="error" show-icon>
        </el-alert>
        <el-form class="formDeclinaison" ref="form" :model="form">
            <el-table :row-class-name="tableRowClassName" style="width: 100%" ref="multipleTable" :data="form.products" stripe>
                <el-table-column prop="visuel">
                    <template slot-scope="scope">
                        <a v-if="scope.row.images.length" href="#" class="mb-3">
                            <span class="avatar" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.images[0].path+'\')'}"></span>
                        </a>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Titre">
                </el-table-column>
                <el-table-column prop="variationsCount" label="Variation existante">
                </el-table-column>
                <el-table-column label="Variation">
                    <template slot-scope="scope" v-if="!scope.row.variationsCount">
                        <el-select v-model="scope.row.datasEditInline.variation_value_id" placeholder="Select" filterable>
                            <el-option :disabled="scope.row.datasEditInline.variation_value_id != item.id && variationSizeAlreadySelected(item)" v-for="item in variationSize.values" :key="item.id" :label="item.value" :value="item.id"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="ean13" label="Code barre">
                    <template slot-scope="scope">
                        <template v-if="!scope.row.editMode">
                            {{ scope.row.ean13 }}
                        </template>
                        <template v-if="scope.row.editMode">
                            <el-input placeholder="Code barre" v-model="scope.row.datasEditInline.ean13"></el-input>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="external_ref" label="Référence fournisseur">
                    <template slot-scope="scope">
                        <template v-if="!scope.row.editMode">
                            {{ scope.row.external_ref }}
                        </template>
                        <template v-if="scope.row.editMode">
                            <el-input placeholder="Référence fournisseur" v-model="scope.row.datasEditInline.external_ref"></el-input>
                        </template>
                    </template>
                </el-table-column>

                <el-table-column label="Variation principal">
                    <template slot-scope="scope">
                        <el-switch :disabled="!scope.row.datasEditInline.productMaster && hasProductMaster" v-model="scope.row.datasEditInline.productMaster" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <template v-if="!scope.row.inlineLoader">
                            <a v-if="!scope.row.editMode" href="#" @click.prevent="edit(scope.row)">
                                <i class="fe fe-edit"></i>
                            </a>
                            <a v-if="scope.row.editMode" href="#" @click.prevent="save(scope.row)">
                                <i class="fe fe-save"></i>
                            </a>
                        </template>
                        <template v-if="scope.row.inlineLoader">
                            <i class="el-icon-loading"></i>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-switch active-text="Syncronisé ?" v-model="sync" ></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { EventBus } from '../../../event-bus';
export default {
    data() {
        return {
            display: false,
            loader: false,
            variationSize: {},
            error: false,
            errorMessage: null,
            sync: false,
            form: {
                products: []
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        hasProductMaster() {
            return this.form.products.filter(
                v => v.datasEditInline.productMaster
            ).length
                ? true
                : false;
        },
        productMaster() {
            return this.form.products.find(
                v => v.datasEditInline.productMaster
            );
        },
        productMasterId() {
            var p = this.form.products.filter(
                v => v.datasEditInline.productMaster
            );
            if (p.length) {
                return p[0].id;
            }
            return null;
        },
        hasProductVariation() {
            return this.selected.filter(v => v.variationsCount).length
                ? true
                : false;
        },
        countProductVariation() {
            return this.selected.filter(v => v.variationsCount).length;
        },
        displayWarningDeclinaison() {
            var masterId = this.productMasterId;
            if (!masterId) return false;
            return this.form.products.filter(
                v => v.variationsCount && v.id != masterId
            ).length
                ? true
                : false;
        }
    },
    methods: {
        open() {
            this.form.products = Array.from(this.selected);

            this.form.products.forEach(v => {
                v.populateEditMode();
            });
            axios.get('/variations/size').then(r => {
                this.variationSize = r.data.data;
                this.display = true;
                this.$store.dispatch('products/setLoader', false);
            });
            console.log(this.form.products);
        },
        action() {
            let datas = { products: [] };
            this.form.products.forEach(v => {
                datas.products.push(v.datasEditInline);
            });
            this.error = false;
            this.errorMessage = null;
            if (!this.hasProductMaster) {
                this.error = true;
                this.errorMessage = 'Merci de choisir une variation principal.';
                return;
            }
            let noVariationValue = datas.products.filter(
                v => !v.variation_value_id && !v.variationsCount
            ).length
                ? true
                : false;
            if (noVariationValue) {
                this.error = true;
                this.errorMessage =
                    'Merci de choisir une taille pour chaque variation.';
                return;
            }
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.sync = this.sync;
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            this.$confirm('Ajouter les variations ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    this.loader = true;
                    axios
                        .post(
                            '/products/' +
                                this.productMasterId +
                                '/variations/many',
                            datas
                        )
                        .then(r => {
                            this.form.products = [];
                            this.sync = false;
                            this.display = false;
                            EventBus.$emit('products.list.refresh');
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                })
                .catch(() => {});
        },
        cancelEditMode() {
            this.form.products.forEach(v => v.cancelEditMode());
        },
        variationSizeAlreadySelected(variationSize) {
            if (
                this.productMaster &&
                this.productMaster.variationsCount &&
                this.productMaster.variationsIds.find(
                    v => v == variationSize.id
                )
            ) {
                return true;
            }

            return this.form.products.filter(
                v => v.datasEditInline.variation_value_id == variationSize.id
            ).length
                ? true
                : false;
        },
        tableRowClassName({ row, rowIndex }) {
            if (
                this.hasProductMaster &&
                !row.datasEditInline.productMaster &&
                row.variationsCount
            ) {
                return 'warning-variation-already';
            }
        },
        edit(product) {
            product.setEditMode();
        },
        save(product) {
            var datas = product.saveEditMode();
            //variation.inlineLoader = true;
        }
    }
};
</script>
